export const LogoMark = ({ className = "w-9 h-9" }) => (
  <svg viewBox="0 0 40 40" className={className} aria-hidden="true">
    <rect x="3.5" y="3.5" width="33" height="33" fill="none" stroke="#D4AF37" strokeWidth="1.5" />
    <path d="M27 12.5H16.5a4 4 0 0 0 0 8h7a4 4 0 0 1 0 8H13" fill="none" stroke="#D4AF37" strokeWidth="2.6" strokeLinecap="square" />
    <path d="M8 8h4M28 32h4" stroke="#D4AF37" strokeWidth="1.5" />
  </svg>
);

export const Logo = () => (
  <span className="flex items-center gap-3">
    <LogoMark />
    <span className="leading-none">
      <span className="block font-display text-[1.35rem] font-semibold tracking-wide text-slate-50">Selby</span>
      <span className="block font-mono text-[0.58rem] tracking-[0.32em] text-gold uppercase mt-0.5">Asset Group</span>
    </span>
  </span>
);
